import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import moment from 'moment'
import Container from '../../../../components/Container'
import api from '../../../../services/api'
import { useToast } from '../../../../hooks/toast'
import { useLoading } from '../../../../hooks/loading'
import { Alert } from '../../../../components/Alert'
import { nameActions } from '../domain/info'
import { apiDelete, apiList } from '../domain/api'
import { breadcrumbView } from '../domain/breadcrumb'
import {
  toolsViewCreate,
  toolsViewDelete,
  toolsViewUpdate,
  toolsViewList
} from '../domain/tools'
import { INPUT_MASK } from '../../../../common/constants'

const ServicesCountriesView = (): JSX.Element => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const { addToast } = useToast()
  const { disableLoading, activeLoading } = useLoading()
  const [servicesCountry, setServicesCountry] =
    useState<ServicesCountriesApiResponse | null>(null)
  const [alertRemove, setAlertRemove] = useState(false)

  useEffect(() => {
    async function loadServicesCountry(): Promise<void> {
      activeLoading()
      try {
        const response = await api.get<ServicesCountriesApiResponse>(
          apiList(id)
        )
        setServicesCountry(response.data)
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao carregar o país de serviço',
          description:
            'Houve um erro ao carregar o país de serviço, tente novamente mais tarde!'
        })
        history.push(nameActions.read.to)
      } finally {
        disableLoading()
      }
    }
    loadServicesCountry()
  }, [activeLoading, addToast, disableLoading, history, id])

  const handleOnClickRemove = () => {
    setAlertRemove(true)
  }

  const handlerOnClickButtonConfirmRemove = async (itemId: number) => {
    try {
      await api.delete(apiDelete(String(itemId)))
      setAlertRemove(false)
      addToast({
        type: 'success',
        title: 'País de serviço removido com sucesso.'
      })
      history.push(nameActions.read.to)
    } catch (err: any) {
      setAlertRemove(false)
      if (err.response?.status === 403) {
        addToast({
          type: 'error',
          title: err.response.data.message
        })
        return
      }
      addToast({
        type: 'error',
        title: 'País de serviço não removido.'
      })
    }
  }

  const handlerOnClickButtonCancelRemove = () => {
    setAlertRemove(false)
  }

  return (
    <div className="d-flex flex-column container-fluid">
      <Container
        pageTitle={nameActions.read.name}
        breadcrumb={breadcrumbView}
        tools={[
          toolsViewUpdate(String(id)),
          toolsViewDelete(() => {
            handleOnClickRemove()
          }),
          toolsViewCreate(),
          toolsViewList()
        ]}
      >
        <div className="form-body">
          <div className="row mb-5">
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6">Cód.</label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {servicesCountry?.id}
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6">Nome</label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {servicesCountry?.name}
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6">Ativo</label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {servicesCountry
                    ? servicesCountry.active
                      ? 'Sim'
                      : 'Não'
                    : '-'}
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6">
                  Cadastrado em
                </label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {servicesCountry?.created_at
                    ? moment(servicesCountry.created_at).format(
                        INPUT_MASK.DATE_LOCALE_WITH_TIME
                      )
                    : '-'}
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6">
                  Atualizado em
                </label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {servicesCountry?.updated_at
                    ? moment(servicesCountry.updated_at).format(
                        INPUT_MASK.DATE_LOCALE_WITH_TIME
                      )
                    : '-'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>

      <Alert
        message={`Tem certeza que deseja excluir o registro ${servicesCountry?.id} ?`}
        onClickCancellButton={handlerOnClickButtonCancelRemove}
        onClickConfirmButton={() =>
          handlerOnClickButtonConfirmRemove(Number(servicesCountry?.id))
        }
        isActive={alertRemove}
      />
    </div>
  )
}

export default ServicesCountriesView
